import React, { useState, useEffect, useRef } from 'react';
import { isAdmin, isDoctor } from './helper/authRoles';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import './CreatePrescription.css'; // Ensure you create this CSS file for styling
import './CreatePatient.css'; // Ensure you create this CSS file for styling
import { faArrowLeft, faCamera } from '@fortawesome/free-solid-svg-icons'; // Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {axiosInstance} from './helper/axiosConfig';
import { districts } from '../data/districts';
import { thanasByDistrict } from '../data/thanasByDistrict';
import { Link, useNavigate } from 'react-router-dom'; // Import navigation hooks
import toast, { Toaster } from 'react-hot-toast';
import moment from 'moment';

const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

function validate_bdnumber(number)
{
  let pattern = /^\+?(88)?0(19|14|17|13|18|16|15)\d{8}$/
  return number.match(pattern) ? true : false;
}

function CreatePatient() {
  const [patientData, setPatientData] = useState({
    name: '',
    mobile: '',
    age: '',
    gender: '',
    height: '',
    weight: '',
    marital_status: '',
    occupation: '',
    address_district: '',
    address_thana: '',
    profile_pic: null // Add the profile picture field
  });

  const [loading, setLoading] = useState(false); // Loading state for the form submission
  const [avatarBgColor, setAvatarBgColor] = useState(getRandomColor());
  const [profilePreview, setProfilePreview] = useState(null); // For previewing the selected profile image
  const [availableThanas, setAvailableThanas] = useState([]); // State for available thanas based on district
  const history = useNavigate(); // Hook for navigation

  useEffect(() => {
    if(!isAdmin()) {
      history('/dashboard'); // Redirect after successful creation
      return;
    }
  }, []);


  // Handle input change for text fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientData({
      ...patientData,
      [name]: value
    });

    // Update available thanas when district changes
    if (name === 'address_district') {
      setAvailableThanas(thanasByDistrict[value] || []); // Get thanas for the selected district
    }
    setLoading(false);
  };


  const calculateDOB = (age) => {
    const currentDate = moment();
    const dob = currentDate.subtract(age, 'years').format('YYYY-MM-DD'); // Format as 'YYYY-MM-DD'
    return dob;
  };

  // Function to calculate Age from Date of Birth
  const calculateAge = (dob) => {
    const currentDate = moment();
    const birthDate = moment(dob, 'YYYY-MM-DD');
    const age = currentDate.diff(birthDate, 'years');
    return age;
  };

  // Handler for Age Input
  const handleAgeChange = (e) => {
    const { value } = e.target;
    const age = value ? parseFloat(value) : ''; // Use parseFloat for decimals

    setPatientData((prevValues) => ({
      ...prevValues,
      age: age,
      dob: age ? calculateDOB(age) : '', // Auto-update DOB
    }));
  };
  // Handler for DOB Input
  const handleDOBChange = (e) => {
    const { value } = e.target;

    setPatientData((prevValues) => ({
      ...prevValues,
      dob: value,
      age: value ? calculateAge(value) : '', // Auto-update Age
    }));
  };



  // Handle profile picture change
  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPatientData({ ...patientData, profile_pic: file });
      setProfilePreview(URL.createObjectURL(file)); // Show a preview of the image
    }
    setLoading(false);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoading(true);

    if (!patientData.name) {
      toast.error("Patient name is required.")
      return;
    }
    if (!patientData.mobile) {
      toast.error('Patient mobile is required.');
      return;
    }
    if (!patientData.age) {
      toast.error('Patient age is required.');
      return;
    }
    if (!patientData.gender) {
      toast.error('Patient gender is required.');
      return;
    }
    if (!patientData.marital_status) {
      toast.error('Patient marital status is required.');
      return;
    }


    const formData = new FormData();
    // Append all form fields to formData
    Object.keys(patientData).forEach((key) => {
      formData.append(key, patientData[key]);
    });
    console.log("this is the form data = xxxxxxxxxxxxxxxxxxxxxxxx = ", formData);
    try {


      await toast.promise(
        axiosInstance.post('/api/patient/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }),
        {
          loading: 'Creating patient...',
          success: <b>Patient created successfully!</b>,
          error: <b>Failed to cerating patient.</b>,
        }
      );



      console.log('Patient created successfully:');
      // setLoading(false);
      history('/patient-history'); // Redirect after successful creation
    } catch (error) {
      console.error('Error creating patient:', error);
      // setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar /> {/* Sidebar component */}
      <div className="dashboard-main">
        <Header /> {/* Header component */}
        <div className="content-box">
          <div className="patient-details-container create-patient">

            {/* Patient Profile Header */}
            <div className="patient-header">
              <div className="back-icon-wrapper">
                <Link to="/patient-history"> <FontAwesomeIcon icon={faArrowLeft} className="back-icon" /> </Link>
              </div>
              <div className="center-content ">
                <h2 className="profile-name">Create New Patient</h2>
                <div className="profile-picture-wrapper">
                  <label htmlFor="profile-pic-input">
                    <div
                      className="profile-picture"
                      style={{
                        backgroundColor: avatarBgColor,
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#fff',
                        fontSize: '36px',
                        fontWeight: 'bold',
                        backgroundImage: profilePreview ? `url(${profilePreview})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                    >
                      {!profilePreview && <FontAwesomeIcon icon={faCamera} className="camera-icon" />}
                    </div>
                  </label>
                  <input
                    id="profile-pic-input"
                    type="file"
                    name="profile_pic"
                    accept="image/*"
                    style={{ display: 'none' }} // Hide the file input
                    onChange={handleProfilePicChange}
                  />
                </div>
              </div>
            </div>

            {/* Patient Information Form */}
            <div className="patient-info-div">
                <div className="patient-info">
                  <form className="patient-info-form create-prescription" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter Patient's Full Name"
                        value={patientData.name}
                        onChange={handleInputChange}
                        required
                      />
                      <label>Full Name *</label>
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Enter Mobile Number  e.g. 01xxx.."
                        pattern="[0-9]{11}"
                        title="Please enter a valid 11-digit Bangladeshi mobile number starting with 01."
                        value={patientData.mobile}
                        onChange={handleInputChange}
                        required
                      />
                      <label>Mobile Number *</label>
                    </div>



                    <div className="form-row">
                      {/* Age Field */}
                      <div class="half left dob-age p-page">
                        <div className="form-group age">
                          <input
                            type="number"
                            name="age"
                            placeholder="Enter Age"
                            value={patientData.age}
                            onChange={handleAgeChange} // New handler for age
                            step="0.1" // Allows 0.1 increments (e.g., 0.1, 0.5, 1.2)
                            required
                          />
                          <label>Age (year)<sup>*</sup></label>
                        </div>

                        {/* Date of Birth Field */}
                        <div className="form-group half left dob">
                          <input
                            type="date"
                            name="dob"
                            placeholder="Enter Date of Birth"
                            value={patientData.dob || ''}
                            onChange={handleDOBChange} // New handler for DOB
                            required
                          />
                          <label>Date of Birth<sup>*</sup></label>
                        </div>
                      </div>


                    {/*
                    <div className="form-row row-double">
                      <div className="form-group">
                        <input
                          type="number"
                          name="age"
                          placeholder="Enter Age"
                          value={patientData.age}
                          onChange={handleInputChange}
                          required
                        />
                        <label>Age *</label>
                      </div>
                      */}

                      <div className="form-group">
                        <select name="gender" value={patientData.gender} onChange={handleInputChange} required>
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Common">Common</option>
                        </select>
                        <label>Gender *</label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <input
                          type="text"
                          name="height"
                          placeholder="Enter Height"
                          value={patientData.height}
                          onChange={handleInputChange}
                        />
                        <label>Height (Feet)</label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="weight"
                          placeholder="Enter Weight"
                          value={patientData.weight}
                          onChange={handleInputChange}
                        />
                        <label>Weight (KG)</label>
                      </div>
                    </div>

                    <div className="form-row ">
                      <div className="form-group">
                        <select name="marital_status" value={patientData.marital_status} onChange={handleInputChange} required>
                          <option value="">Select Marital Status</option>
                          <option value="Single">Single</option>
                          <option value="Married">Married</option>
                          <option value="Divorced">Divorced</option>
                          <option value="Widowed">Widowed</option>
                          <option value="Separated">Separated</option>
                        </select>
                        <label>Marital Status *</label>
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          name="occupation"
                          placeholder="Select Occupation"
                          value={patientData.occupation}
                          onChange={handleInputChange}
                        />
                        <label>Occupation</label>
                      </div>
                    </div>

                    {/* District and Thana Dropdowns */}
                    <h4>Address</h4>
                    <div className="form-row row-double">
                      <div className="form-group">
                        <select
                          name="address_district"
                          value={patientData.address_district}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select District</option>
                          {districts.map((district) => (
                            <option key={district.name} value={district.name}>
                              {district.name}
                            </option>
                          ))}
                        </select>
                        <label>District</label>
                      </div>

                      <div className="form-group">
                        <select
                          name="address_thana"
                          value={patientData.address_thana}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Thana</option>
                          {availableThanas.map((thana) => (
                            <option key={thana} value={thana}>
                              {thana}
                            </option>
                          ))}
                        </select>
                        <label>Thana</label>
                      </div>
                    </div>

                    <div className="form-group submit-button-container">
                      <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Creating...' : '+ Create Patient'}
                      </button>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default CreatePatient;
